import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
// import { Skills } from "./components/Skills"; // Courses section, hidden for now
import { Projects } from "./components/Projects";
import { Achievements } from "./components/Achievements";
import { OpenSource } from "./components/OpenSource";
import { Blogs } from "./components/Blogs";
import { About } from "./components/About";
import { Footer } from "./components/Footer";

const Home = () => {
  useDocumentTitle(
    "Arnav Panjla | 0xArnav — Systems Programmer & Cryptography Researcher",
    "Arnav Panjla (0xArnav) — B.Tech EE'27 at IIT Delhi. Systems programmer and cryptography researcher working in Rust, FPGAs, zero-knowledge proofs and robotics."
  );
  return (
    <>
      <Banner />
      <Achievements />
      <OpenSource />
      <Projects />
      <Blogs />
      {/* <Skills /> */}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <NavBar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
